<template>
  <div class="flex items-center gap-6">
    <NavMainBarAllCategoriesButton
      v-if="!isLoginPage"
    />
    <SimpleCarousel
      :slider-items="categories"
      slide-class="py-2"
      :has-custom-last-item="true"
      :arrows="true"
      :hide-arrows-on-boundaries="true"
      :slides-auto-width="true"
      :gap="8"
      :height="48"
      class="w-full overflow-auto"
    >
      <template #default="{ currentItem }">
        <NavMainBarCategory
          :current-item="currentItem"
        />
      </template>
      <template #prev="{ prevArrowClicked }">
        <div
          class="left-0"
          :class="arrowClass.container"
          data-testid="mainNavCarouselPrevButton"
          @click="prevArrowClicked(SIMPLE_CAROUSEL_ARROW.prev)"
        >
          <span
            :class="arrowClass.arrow"
            class="iconify svg--chevron-left"
          />
        </div>
      </template>
      <template #next="{ nextArrowClicked }">
        <div
          class="right-0"
          :class="arrowClass.container"
          data-testid="mainNavCarouselNextButton"
          @click="nextArrowClicked(SIMPLE_CAROUSEL_ARROW.next)"
        >
          <span
            :class="arrowClass.arrow"
            class="iconify svg--chevron-right"
          />
        </div>
      </template>
      <template #custom-last-item>
        <NavMainBarOnSale
          :class="{'hidden': hideOnSaleLink}"
        />
      </template>
    </SimpleCarousel>
  </div>
</template>

<script lang="ts">

import type { Category } from '~~/types/commercetools';
import { SIMPLE_CAROUSEL_ARROW } from '~~/types/components/SimpleCarousel/SimpleCarouselArrows';

export default defineComponent({
  name: 'NavMainBarDesktop',

  props: {
    categories: {
      type: Array as PropType<Category[]>,
      default: () => {

        return [];
      
      },
    },
    hideOnSaleLink: {
      type: Boolean,
      default: false,
    },
  },
  setup() {

    const arrowClass = {
      container: `absolute bg-EXPONDO-primary-10 h-full w-10 z-1 top-0
      flex items-center justify-center cursor-pointer`,
      arrow: 'text-EXPONDO-primary text-xl',
    };
    const { isLoginPage } = useIsPage();

    return {
      SIMPLE_CAROUSEL_ARROW,
      arrowClass,
      isLoginPage,
    };
  
  },
});

</script>
